<template>
    <div class="group">
        <label v-on:click="active = true">Last name</label>
        <input type="text" class="validation" v-bind:class="{ '-invalid': $parent.validation.lastname } "  v-model="$parent.fields.lastname" v-on:keyup="$parent.validation.lastname = null" @focus="active = true" @blur="blur('lastname')" ref="el">
        <div class="error-message" v-for="message in $parent.validation.lastname">{{ message }}</div>
    </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'lastname',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ]
    }
</script>
